import React, { useContext, createContext } from "react";
import styles from "./usernavigator.module.css";
import PersonIcon from "@mui/icons-material/Person";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import logo from "../../assets/logo.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { NavigationContext } from "../../context/navigation";
import ImageWithFallback from '../ImageWithFallback';

const UserNavigator = React.memo(() => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { open, setOpen, openChild, setOpenChild } =
    useContext(NavigationContext);

  const handleClick = (type, path) => {
    setOpen({
      ...open,
      isAccount: type === "isAccount",
      isOrder: type === "isOrder",
      isNotification: type === "isNotification",
      isVoucher: type === "isVoucher",
    });
    navigate(path);
  };

  const handleChildOpen = (type, path) => {
    setOpenChild({
      ...openChild,
      isProfile: type === "isProfile",
      isBank: type === "isBank",
      isResetPass: type === "isResetPass",
    });
    navigate(path);
  };

  return (
    <div className={styles.userNavigator}>
      <div className={styles.userDisplay}>
        <ImageWithFallback
          loading="lazy"
          className={styles.avatarImg}
          src={logo}
          alt="avatar"
        />
        <div className={styles.userName}>Name</div>
      </div>
      <div className={styles.menu}>
        <div className={styles.menuItemBox}>
          <div
            className={open.isAccount ? styles.menuItemActive : styles.menuItem}
            onClick={() => handleClick("isAccount")}
          >
            <PersonIcon sx={{ fontSize: 30, color: "black" }} />
            <span>{t("my_account")}</span>
          </div>
          <div
            className={
              open.isAccount
                ? styles.menuItemChildContainerOpen
                : styles.menuItemChildContainer
            }
          >
            <a
              className={
                openChild.isProfile
                  ? styles.menuItemChildActive
                  : styles.menuItemChild
              }
              onClick={() => handleChildOpen("isProfile", "/user")}
            >
              <span>{t("profile")}</span>
            </a>
            <a
              className={
                openChild.isBank
                  ? styles.menuItemChildActive
                  : styles.menuItemChild
              }
              onClick={() => handleChildOpen("isBank")}
              href="#"
            >
              <span>{t("bank")}</span>
            </a>
            <a
              className={
                openChild.isResetPass
                  ? styles.menuItemChildActive
                  : styles.menuItemChild
              }
              onClick={() =>
                handleChildOpen("isResetPass", "/user/reset-password")
              }
            >
              <span>{t("reset_pass")}</span>
            </a>
          </div>
        </div>
        <div className={styles.menuItemBox}>
          <div
            className={open.isOrder ? styles.menuItemActive : styles.menuItem}
            onClick={() => handleClick("isOrder", "/user/orders")}
          >
            <ShoppingBasketIcon sx={{ fontSize: 30, color: "black" }} />
            <span>{t("order")}</span>
          </div>
        </div>
        <div className={styles.menuItemBox}>
          <div
            className={
              open.isNotification ? styles.menuItemActive : styles.menuItem
            }
            onClick={() => handleClick("isNotification")}
          >
            <NotificationsIcon sx={{ fontSize: 30, color: "black" }} />
            <span>{t("notification")}</span>
          </div>
        </div>
        <div className={styles.menuItemBox}>
          <div
            className={open.isVoucher ? styles.menuItemActive : styles.menuItem}
            onClick={() => handleClick("isVoucher")}
          >
            <ConfirmationNumberIcon sx={{ fontSize: 30, color: "black" }} />
            <span>{t("voucher")}</span>
          </div>
        </div>
      </div>
    </div>
  );
});

export { UserNavigator };
